import { createAdapterRegistry } from "../../core/index";
import {
  registerSelectionAdapter,
  hydrateSelectionFromSession,
} from "./selection.adapter";
import {
  registerHelpersAdapter,
  hydrateHelpersFromSession,
} from "./helpers.adapter";
import {
  registerViewportAdapter,
  hydrateViewportFromSession,
} from "./viewport.adapter";
import { registerThemeAdapter, hydrateThemeFromSession } from "./theme.adapter";
import { registerI18nAdapter, hydrateI18nFromSession } from "./i18n.adapter";
import {
  registerBreakpointAdapter,
  hydrateBreakpointFromSession,
} from "./breakpoint.adapter";
import { registerAudioAdapter, hydrateAudioFromSession } from "./audio.adapter";
import {
  registerHandednessAdapter,
  hydrateHandednessFromSession,
} from "./handedness.adapter";

export {
  registerSelectionAdapter,
  hydrateSelectionFromSession,
} from "./selection.adapter";

export {
  registerViewportAdapter,
  hydrateViewportFromSession,
} from "./viewport.adapter";

export {
  registerHelpersAdapter,
  hydrateHelpersFromSession,
} from "./helpers.adapter";

export { registerThemeAdapter, hydrateThemeFromSession } from "./theme.adapter";

export { registerI18nAdapter, hydrateI18nFromSession } from "./i18n.adapter";

export {
  registerBreakpointAdapter,
  hydrateBreakpointFromSession,
} from "./breakpoint.adapter";

export { registerAudioAdapter, hydrateAudioFromSession } from "./audio.adapter";
export {
  registerHandednessAdapter,
  hydrateHandednessFromSession,
} from "./handedness.adapter";

export const createScreenRegistry = (deps: any) => {
  const registry = createAdapterRegistry(deps);
  try {
    registry.register(
      () =>
        ({
          startBridge: () => registerSelectionAdapter(deps),
          hydrateFromSession: (
            screen: Record<string, unknown> | null | undefined
          ) => hydrateSelectionFromSession(deps, screen),
        } as any)
    );
  } catch {}
  try {
    registry.register(
      () =>
        ({
          startBridge: () => registerHelpersAdapter(deps),
          hydrateFromSession: (
            screen: Record<string, unknown> | null | undefined
          ) => hydrateHelpersFromSession(deps, screen),
        } as any)
    );
  } catch {}
  try {
    registry.register(
      () =>
        ({
          startBridge: () => registerViewportAdapter(deps),
          hydrateFromSession: (
            screen: Record<string, unknown> | null | undefined
          ) => hydrateViewportFromSession(deps, screen),
        } as any)
    );
  } catch {}
  try {
    registry.register(
      () =>
        ({
          startBridge: () => registerThemeAdapter(deps),
          hydrateFromSession: (
            screen: Record<string, unknown> | null | undefined
          ) => hydrateThemeFromSession(deps, screen),
        } as any)
    );
  } catch {}
  try {
    registry.register(
      () =>
        ({
          startBridge: () => registerI18nAdapter(deps),
          hydrateFromSession: (
            screen: Record<string, unknown> | null | undefined
          ) => hydrateI18nFromSession(deps, screen),
        } as any)
    );
  } catch {}
  try {
    registry.register(
      () =>
        ({
          startBridge: () => registerBreakpointAdapter(deps),
          hydrateFromSession: (
            screen: Record<string, unknown> | null | undefined
          ) => hydrateBreakpointFromSession(deps, screen),
        } as any)
    );
  } catch {}
  try {
    registry.register(
      () =>
        ({
          startBridge: () => registerAudioAdapter(deps),
          hydrateFromSession: (
            screen: Record<string, unknown> | null | undefined
          ) => hydrateAudioFromSession(deps, screen),
        } as any)
    );
  } catch {}
  try {
    registry.register(
      () =>
        ({
          startBridge: () => registerHandednessAdapter(deps),
          hydrateFromSession: (
            screen: Record<string, unknown> | null | undefined
          ) => hydrateHandednessFromSession(deps, screen),
        } as any)
    );
  } catch {}
  return registry;
};
